import React, {useState} from 'react';
import PropTypes from 'prop-types';
import "react-image-lightbox/style.css";
import WorkPositions from "./WorkStep/WorkPositions";
import WorkParts from "./WorkStep/WorkParts";
import Button from "../../Button";
import {useTecRmi} from "../../../contexts/TecRmiContext";

const WorkStep = props => {
  const {timesWorkStepChoose} = useTecRmi()
  const [partsData, setPartsData] = useState()
  const [adding, setAdding] = useState(false)

  const getWorkPositions = () => {
    if(props.workStep.ExclusiveWorkPositions.length > 0){
      return props.workStep.ExclusiveWorkPositions
    }else{
      return [
        props.workStep
      ]
    }
  }

  return (
    <div>
      {timesWorkStepChoose && <Button
        className="ml-auto mb-2"
        loading={adding}
        onClick={() => {
          setAdding(true)
          timesWorkStepChoose.fn({
            workPositions: getWorkPositions(),
            partsData,
          })
            .then(() => {
              setAdding(false)
            })
        }}
      >{timesWorkStepChoose.btnText}</Button>}
      <div className="mb-3">
        <WorkPositions
          workPositions={getWorkPositions()}
        />
      </div>

      <WorkParts
        bodyForTimes={props.bodyForTimes}
        workIds={getWorkPositions().map(exclusiveWorkPosition => exclusiveWorkPosition.WorkId)}
        onChange={setPartsData}
      />
    </div>
  );
};

WorkStep.propTypes = {
  bodyForTimes: PropTypes.number.isRequired,
  workStep: PropTypes.shape({
    ItemMpId: PropTypes.number.isRequired,
    KorId: PropTypes.number.isRequired,
    ExclusiveWorkPositions: PropTypes.arrayOf(PropTypes.shape({
      ItemMpText: PropTypes.string.isRequired,
      KorText: PropTypes.string.isRequired,
      QualColId: PropTypes.number.isRequired,
      QualColText: PropTypes.string.isRequired,
      WorkTime: PropTypes.number.isRequired,
      WorkId: PropTypes.number.isRequired,
    })),
    OptionalExclusivePositions: PropTypes.any, //TODO
  }).isRequired,
};

export default WorkStep;